import { render, staticRenderFns } from "./EditResult.vue?vue&type=template&id=9e644c46&scoped=true"
import script from "./EditResult.vue?vue&type=script&lang=js"
export * from "./EditResult.vue?vue&type=script&lang=js"
import style0 from "./EditResult.vue?vue&type=style&index=0&id=9e644c46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e644c46",
  null
  
)

export default component.exports